import React from "react";
import {
    Box,
    Divider,
    Drawer,
    IconButton,
    Link,
    List,
    Stack,
    Typography,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AdministratorMenu from "./AdministratorMenu";
import { ReactComponent as Logo } from "../assets/KaproSCMIcon.svg";
import semenarnaLogo from "../assets/semenarna.png";

const DRAWER_WIDTH = 280;

const MobileSidebar = ({ open, onClose }) => (
    <Drawer
        anchor="left"
        open={open}
        onClose={onClose}
        PaperProps={{
            sx: {
                width: DRAWER_WIDTH,
                bgcolor: "background.paper",
                backgroundImage: "none",
                borderRight: (theme) => `1px solid ${theme.palette.divider}`,
                display: "flex",
                flexDirection: "column",
            },
        }}
    >
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ px: 2, py: 1.5, minHeight: 64 }}
        >
            <Stack direction="row" alignItems="center" spacing={1.5}>
                <Box sx={{ width: 36, height: 36 }}>
                    <Logo style={{ width: "100%", height: "100%" }} />
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: "0.2px" }}>
                    KaproSCM
                </Typography>
            </Stack>
            <IconButton onClick={onClose} edge="end">
                <CloseRoundedIcon />
            </IconButton>
        </Stack>

        <Divider />

        <Box sx={{ px: 1, py: 2, flex: 1, overflowY: "auto" }}>
            <List
                component="nav"
                sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
            >
                <AdministratorMenu collapsed={false} onItemClick={onClose} />
            </List>
        </Box>

        <Box sx={{ p: 2 }}>
            <Link
                href="https://www.semenarna.si/"
                target="_blank"
                rel="noopener"
                sx={(theme) => ({
                    display: "flex",
                    justifyContent: "center",
                    p: 2,
                    borderRadius: 2,
                    bgcolor:
                        theme.palette.mode === "dark"
                            ? "rgba(255,255,255,0.04)"
                            : "rgba(15,23,42,0.04)",
                })}
            >
                <Box
                    component="img"
                    src={semenarnaLogo}
                    alt="Semenarna"
                    sx={(theme) => ({
                        maxWidth: "100%",
                        height: "auto",
                        filter:
                            theme.palette.mode === "dark"
                                ? "brightness(1.1)"
                                : "invert(1)",
                    })}
                />
            </Link>
        </Box>
    </Drawer>
);

export default MobileSidebar;